/** Partner fleet pricing from Travelopro / search API fields on VehicleCard payloads. */

import { vehicleCurrency } from "./currencyDisplay";

export function partnerTripDays(v) {
  const d = v?.trip_days ?? v?.partner_meta?.duration_days;
  return d ? Number(d) : null;
}

export function partnerTripTotal(v) {
  const t = v?.trip_total ?? v?.partner_meta?.rate_total;
  return t != null && Number(t) > 0 ? Number(t) : null;
}

export function partnerCurrency(v) {
  return v?.trip_currency || v?.partner_meta?.currency || vehicleCurrency(v);
}

/** Subtotal for `days` rental nights — prefers API trip total when search duration matches. */
export function partnerSubtotal(v, days) {
  const tripTotal = partnerTripTotal(v);
  const tripDays = partnerTripDays(v);
  if (tripTotal && tripDays && days === tripDays) return tripTotal;
  const daily = Number(v?.daily_rate) || 0;
  return daily * Math.max(0, days);
}

export function formatMoney(amount, currency = "USD") {
  const n = Number(amount);
  if (!Number.isFinite(n)) return "—";
  try {
    return new Intl.NumberFormat(undefined, { style: "currency", currency, maximumFractionDigits: 2 }).format(n);
  } catch {
    return `${currency} ${n.toFixed(2)}`;
  }
}
